<template>
	<div class="sticky-top" style="top: 1rem">
		<b-card header="Preview" class="mb-3">
			<b-aspect aspect="16:9" class="d-flex align-items-center justify-content-center preview mb-3">
				<p class="text-muted mb-0 text-center">Coming soon</p>
			</b-aspect>
			<b-form-group label="OBS browser source URL">
				<b-input-group label-for="widget-url" class="mb-0">
					<b-form-input id="widget-url" readonly :type="showWidgetUrl?'text':'password'" :value="`${$baseUrl}/widget/${slug}.html?hash=${encodeURIComponent($parent.$parent.$parent.user.widget_hash)}`" @focus="$event.target.select()"/>
					<b-input-group-append><b-button variant="outline-info" @click="showWidgetUrl=!showWidgetUrl"><b-icon icon="eye"></b-icon></b-button></b-input-group-append>
					<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(`${$baseUrl}/widget/${slug}.html?hash=${encodeURIComponent($parent.$parent.$parent.user.widget_hash)}`, 'Copied widget URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
				</b-input-group>
			</b-form-group>
		</b-card>
	</div>
</template>

<style lang="scss">
@import '@/plugins/variable.scss';

.preview {
	background: repeating-conic-gradient(#666 0% 25%, #999 0% 50%) 0 / 32px 32px;

	p.text-muted {
		filter: drop-shadow(0 1px 1px $gray-200) drop-shadow(0 -1px 1px $gray-200) drop-shadow(1px 0 1px $gray-200) drop-shadow(-1px 0 1px $gray-200);
		color: $body-color;
	}
}
</style>

<script>
export default {
	props: {
		slug: String,
		name: String,
	},
	data() { return {
		showWidgetUrl: false,
	}; },
	methods: {
		copyAndToast(string, message, dropdown) {
			let target;
			if(dropdown) {
				target = dropdown.target;
				while(target.nodeName != 'DIV')
					target = target.parentNode;
			}
			this.$util.copyToClipboard(string, target);
			this.$bvToast.toast(message, { title: 'Success', variant: 'success', solid: true });
		},
	},
};
</script>
